export default "__VITE_ASSET__BIl0F9vl__"